import { FaWhatsapp } from "react-icons/fa";
import styled, { keyframes } from "styled-components";

const shake = keyframes`
  0% { transform: rotate(0deg); }
  25% { transform: rotate(10deg); }
  50% { transform: rotate(-10deg); }
  75% { transform: rotate(10deg); }
  100% { transform: rotate(0deg); }
`;

const Text = styled.span`
  font-size: 1rem;
  font-weight: 500;
`;
const TextMobile = styled.span`
  font-size: 1rem;
  font-weight: 500;
  display: none;
`;
const ButtonWrapper = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: black;
  color: white;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 60px;
  cursor: pointer;
  z-index: 99;
  transition: all 0.3s ease;

  @media (max-width: 800px) {
    width: 120px;
    ${Text} {
      display: none;
    }
    ${TextMobile} {
      display: initial;
    }
  }

  &:hover .whatsapp-icon {
    animation: ${shake} 0.5s ease-in-out;
  }
`;

const Icon = styled(FaWhatsapp)`
  font-size: 1.8rem;
  margin-right: 10px;
  color: white;
`;

function FloatingChatButton() {
  return (
    <ButtonWrapper
      onClick={() => {
        window.open("https://wa.link/ytkgxt");
      }}
    >
      <Icon className="whatsapp-icon" />
      <Text>Chat with us</Text>
      <TextMobile>Chat</TextMobile>
    </ButtonWrapper>
  );
}

export default FloatingChatButton;
